import { AsyncAction } from 'actions/actions.types'
import { definitions } from 'api/generated/seo'
import { NodeHeaders } from 'api/NodeHeaders'
import { fetchBreadCrumbsProfileApi } from 'api/seo/breadCrumbsApi'

export const FETCH_BREAD_CRUMBS_PROFILE = 'FETCH_BREAD_CRUMBS_PROFILE'

export interface FetchBreadCrumbsProfileAction
  extends AsyncAction<definitions['SeoLink'][]> {
  type: typeof FETCH_BREAD_CRUMBS_PROFILE
}

export const fetchBreadCrumbsProfileAction = (
  userId: number,
  headers?: NodeHeaders
) => ({
  type: FETCH_BREAD_CRUMBS_PROFILE,
  promise: () => fetchBreadCrumbsProfileApi(userId, headers),
})
